import type { AddFundMergeCommandData } from '@festina/unitlink-general-types/unitlink'
import { typeUtils } from '@festina-life/core'
import {
  FormikDateInput,
  FormikForm,
  FormikTextInput,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../../lenteHooks'
import type { CommandPaletteFormProps } from '../../commandActions/commandPalette/CommandPaletteModalButton'

const validateKey = typeUtils.createValidator<AddFundMergeCommandData>()

export const AddFundMergeForm = (
  props: CommandPaletteFormProps<AddFundMergeCommandData>,
) => {
  const translate = useTranslate()

  const { isinKey } = useHook('routing.general.useFundPricesParams')()
  const initialValues: AddFundMergeCommandData = {
    _type: 'AddFundMergeCommandData',
    isinKey,
    fundMerge: {
      _type: 'FundMerge',
    },
  }

  return (
    <FormikForm initialValues={initialValues} {...props}>
      <FormikDateInput
        name={validateKey('fromDate')}
        label={translate('addFundMergeCommandData.fromDate')}
      />
      <FormikTextInput
        name={validateKey('isinKey')}
        label={translate('addFundMergeCommandData.isinKey')}
      />
      <FormikDateInput
        name={validateKey('fundMerge.date')}
        label={translate('addFundMergeCommandData.fundMerge.date')}
      />
      <FormikTextInput
        name={validateKey('fundMerge.destinationIsinKey')}
        label={translate('addFundMergeCommandData.fundMergedestinationIsinKey')}
      />
    </FormikForm>
  )
}
